import { Card, Flex, Spin, Typography } from "antd"

import CardInfo from "./CardInfo"

const { Text } = Typography

// One metric card of Admin Analytics → Deflect, the platform's chart card (as the merchant Deflect
// Section): title with its info icon (DAA-1-12), the "Not affected by" line under it (DAA-1-13),
// and the card's KPIs and panels as children. `info` is the card's Tooltip table,
// [{ name, formula }]. While `loading`, a spinner covers the card and the previous data stays
// underneath (DAA-1-17).
const MetricCard = ({ title, info, notAffectedBy, loading, children }) => (
  <Card
    data-intro
    className="card-chart-wrapper withTitle"
    styles={{ header: { border: "none" } }}
    title={
      <Flex vertical gap={4}>
        <Flex align="center" gap={8}>
          <span>{title}</span>
          {info && <CardInfo title={title} terms={info} notAffectedBy={notAffectedBy} />}
        </Flex>
        {/* Regular weight and wrapping, unlike the bold, one-line card head around it. */}
        {notAffectedBy && (
          <Text type="secondary" style={{ fontWeight: 400, whiteSpace: "normal" }}>
            {notAffectedBy}
          </Text>
        )}
      </Flex>
    }
  >
    <Spin spinning={loading}>{children}</Spin>
  </Card>
)

export default MetricCard
